export class BillJobFileLocationDetails {
	public accountNumberIdentifier?: string;
	public accountNumber?: string;
	public meterNumberIdentifier?: string;
	public meterNumber?: string[];
	public state?: string;
	public city?: string;
	public address1?: string;
	public address2?: string;
	public serviceAddress?: string;
	public rateClass?: string;
	public zipCode?: string;
	public totalUsage?: number;
	public usageHistory?: { month: string; usage: number }[];
	public deliveryRate?: number;
	public deliveryCharge?: number;
	public taxRate?: number;
	public taxCharge?: number;
	public supplyRate?: number;
	public supplyCharge?: number;
	// public notes?: { }[];

	constructor(billJobFileLocationDetails?: BillJobFileLocationDetails) {
		Object.assign(this, billJobFileLocationDetails);
	}
}
